import React from 'react'
import { TooltipStyles } from './Styled'

const SystemTooltip = (props) => {
    const { title, open } = props

    return (
        <TooltipStyles>
            {open &&
                <div className='description-tooltip'>
                    <div className='tooltip-corner'></div>
                    <div className='tooltip-title'>{title}</div>
                </div>}
        </TooltipStyles>
    )
}

export default SystemTooltip